"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/contracts/dex/v2_1/constants.ts
var DEX_OP_CODES = {
  SWAP: 1717886506,
  CROSS_SWAP: 1775180379,
  PROVIDE_LP: 935368415,
  DIRECT_ADD_LIQUIDITY: 267960262,
  REFUND_ME: 321624620,
  RESET_GAS: 701638965,
  COLLECT_FEES: 518295838,
  BURN: 1499400124,
  WITHDRAW_FEE: 894160372
};
var TX_DEADLINE = 15 * 60;




exports.DEX_OP_CODES = DEX_OP_CODES; exports.TX_DEADLINE = TX_DEADLINE;
//# sourceMappingURL=chunk-C3OQGEQI.cjs.map